import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { disabledSelectRowSetting } from "../../../../helpers/helpers";
import { i18n } from "../../private/languageSelector";
import { getEnvironmentLabel, getPosEnvironment } from "./zatcaEnvironment";
import Selector from "react-select";
import Logs from "./Logs";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storesSlice } from "../../../../_redux/stores/storeSlice";
import * as zatcaActions from "../../../../_redux/zatca/zatcaActions";
import moment from "moment";
function Zatca() {
  const language = localStorage.getItem("language");
  const [pointOfSales, setPointOfSales] = useState([]);
  const [stores, setStores] = useState([]);
  const [zatcaSearchName, setZatcaSearchName] = useState("");
  const dispatch = useDispatch();

  const { allZatcaLogs, totalCount, companyForEdit, allLogsCount } = useSelector((state) => ({
    allZatcaLogs: state.zatca.zatcaLogs,
    totalCount: state.zatca.totalLogsCount,
    companyForEdit: state.company.companyForEdit,
    allLogsCount: state.zatca.allLogsCount,
  }));

  const tableColumns = [
    {
      dataField: "id",
      text: i18n("Integration.PosId"),
      headerAlign: "start",
      headerStyle: {
        textAlign: "left",
        fontWeight: "400",
        fontSize: "14px",
        color: "#828282",
      },
      align: language === "arabic" ? "start" : "left",
      style: {
        paddingTop: "15px",
        paddingBottom: "15px",
      },
    },
    {
      dataField: "name",
      text: i18n("Integration.PosName"),
      headerAlign: "start",
      headerStyle: {
        textAlign: "left",
        fontWeight: "400",
        fontSize: "14px",
        color: "#828282",
      },
      align: language === "arabic" ? "start" : "left",
      style: {
        paddingTop: "15px",
        paddingBottom: "15px",
      },
    },
    {
      dataField: "storeName",
      text: i18n("Integration.Store"),
      headerAlign: "start",
      headerStyle: {
        textAlign: "left",
        fontWeight: "400",
        fontSize: "14px",
        color: "#828282",
      },
      align: language === "arabic" ? "start" : "left",
      style: {
        paddingTop: "15px",
        paddingBottom: "15px",
      },
    },
    {
      dataField: "status",
      text: i18n("Integration.Status"),
      headerAlign: "start",
      headerStyle: {
        textAlign: "left",
        fontWeight: "400",
        fontSize: "14px",
        color: "#828282",
      },
      align: language === "arabic" ? "start" : "left",
      style: {
        paddingTop: "15px",
        paddingBottom: "15px",
      },
    },
    {
      dataField: "type",
      text: i18n("Integration.Type"),
      headerAlign: "start",
      headerStyle: {
        textAlign: "left",
        fontWeight: "400",
        fontSize: "14px",
        color: "#828282",
      },
      align: language === "arabic" ? "start" : "left",
      style: {
        paddingTop: "15px",
        paddingBottom: "15px",
      },
    },
    {
      dataField: "expiresAt",
      text: i18n("Integration.Expiration"),
      headerAlign: "start",
      headerStyle: {
        textAlign: "left",
        fontWeight: "400",
        fontSize: "14px",
        color: "#828282",
      },
      align: language === "arabic" ? "start" : "left",
      style: {
        paddingTop: "15px",
        paddingBottom: "15px",
      },
      formatter: (cell) => {
        return <div style={{ color: cell === "Expired" ? "#FF5F57" : "" }}>{cell}</div>;
      },
    },
  ];

  const fetchAllPos = async () => {
    let allPos = await axios.get(`api/pos?skipPagination=${true}`);
    let refactoredPos = allPos?.data?.pointOfSales?.map((item) => {
      return {
        ...item,
        id: item?.businessId,
        storeName: item?.store?.name,
        status:
          item?.zatca?.certificateId?.length > 0 && item?.zatca?.onboardedAt && !item?.zatca?.isExpired
            ? i18n("Integration.Active")
            : i18n("Integration.Inactive"),
        type: item?.zatca?.certificateId?.length > 0 && item?.zatca?.onboardedAt ? getEnvironmentLabel(getPosEnvironment(item)) : "",
        expiresAt:
          !item?.zatca?.isExpired && item?.zatca?.expiresAt
            ? moment(item?.zatca?.expiresAt)?.format("DD MMM YYYY")
            : item?.zatca?.isExpired
            ? "Expired"
            : "",
      };
    });
    setPointOfSales([...refactoredPos]);
  };

  const fetchAllStores = async () => {
    let response = await axios.get(`api/store?skipPagination=${true}`);
    let allStores = response?.data?.stores?.map((item) => {
      return { ...item, isSelected: true, value: item?.businessId, name: item?.name };
    });
    let defaultStoreValue = { name: i18n("Integration.AllStores"), value: "all", isSelected: true };
    setStores([defaultStoreValue, ...allStores]);
  };

  useEffect(() => {
    fetchAllStores();
    fetchAllPos();
  }, []);

  let handleChangeStores = async (option) => {
    if (option?.value !== "all") {
      let allPos = await axios.get(`api/pos?skipPagination=${true}`);
      let refactoredPos = allPos?.data?.pointOfSales?.map((item) => {
        return { ...item, id: item?.businessId, storeName: item?.store?.name, status: item?.isActive ? "Active" : "Inactive" };
      });
      let filteredPos = refactoredPos?.filter((item) => item?.store?.storeId === option?.storeId);
      setPointOfSales(filteredPos);
    } else {
      fetchAllPos();
    }
  };
  const history = useHistory();
  const handleEditPosClick = (row) => {
    history.push(`/zatca/${row?._id}`);
  };

  useEffect(() => {
    if (companyForEdit?._id) {
      let searchData = {
        searchName: zatcaSearchName,
        limit: 10,
        // actionId: moduleId,
      };
      dispatch(zatcaActions.getAllZatcaOnboardingLogs(companyForEdit?._id, searchData));
    }
  }, [dispatch, zatcaSearchName, companyForEdit]);

  const loadMoreZatcaLogs = () => {
    if (companyForEdit?._id) {
      let searchData = {
        searchName: zatcaSearchName,
        limit: +totalCount + 10,
        // actionId: moduleId,
      };
      dispatch(zatcaActions.getAllZatcaOnboardingLogs(companyForEdit?._id, searchData));
    }
  };

  return (
    <div className="zatca-wrapper">
      <div className={`row ${language === "arabic" ? "flex-row-reverse " : "flex-row "}`}>
        <div className="col-8 px-4 py-5 bg-white rounded">
          <div className={`d-flex justify-content-between align-items-center ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
            <div className={`${language === "arabic" ? "rtl text-right" : "ltr text-left"}`}>
              <div className="title-text">{i18n("Integration.IntegrationWithFatoora")}</div>
              <div className="muted-text pt-1">{i18n("Integration.SubmitDocsToZatca")}</div>
            </div>
            <div style={{ minWidth: "300px" }}>
              <div className="form-group input-select w-100">
                <Selector
                  placeholder={i18n("Integration.Store")}
                  value={(() => {
                    const selected = stores.find((s) => s.isSelected);
                    return selected ? { value: selected.value, label: selected.name } : null;
                  })()}
                  options={stores.map((item) => ({
                    value: item.value,
                    label: item.name,
                    storeId: item?.storeId,
                  }))}
                  onChange={(option) => {
                    setStores((prev) =>
                      prev.map((item) => (item.value === option.value ? { ...item, isSelected: true } : { ...item, isSelected: false })),
                    );
                    handleChangeStores(option);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: "none",
                      boxShadow: "none",
                      backgroundColor: "#F9F9F9",
                      minHeight: "38px",
                    }),
                    indicatorSeparator: () => ({ display: "none" }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      color: "#4F4F4F",
                    }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className={`margin-top-2 ${language === "arabic" ? "rtl" : "ltr"}`}>
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              remote
              bordered={false}
              bootstrap4
              keyField="_id"
              columns={tableColumns}
              data={pointOfSales}
              selectRow={disabledSelectRowSetting}
              rowClasses="cursor-pointer"
              rowEvents={{
                onClick: (e, row) => {
                  handleEditPosClick(row);
                  dispatch(storesSlice.actions.showLayout(false));
                },
              }}
              //   onTableChange={(type, { page, sizePerPage, sortField, sortOrder, data }) =>
              //     handleSorting(type, sortOrder, sortField, data, page, sizePerPage)
              //   }
            />
            {pointOfSales?.length === 0 ? (
              <>
                <div className="empty-data-text">{i18n("Integration.NoPosToDisplay")}</div>
              </>
            ) : null}
          </div>
        </div>
        <div className="col px-4 ">
          <Logs
            allLogs={allZatcaLogs}
            totalCount={totalCount}
            setSearchValue={setZatcaSearchName}
            searchValue={zatcaSearchName}
            loadMoreZatcaLogs={loadMoreZatcaLogs}
            allLogsCount={allLogsCount}
          />
        </div>
      </div>
    </div>
  );
}

export default Zatca;
